module.exports = __webpack_public_path__ + "img/Wp_2036.53b7dcbc.png";